export default __webpack_public_path__ + "static/nodejsDev-1f9606a7506eb028e414e8d844253138.jpg";